<div>{{'logout.loggingOut' | translate}}</div>
